module.exports = __webpack_public_path__ + "static/media/swordraw.ae4e6a47.mp3";